module.exports = __webpack_public_path__ + "img/geolocalisation.ddd6c402.png";